import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CurriculumTrainingItemGroupManagementService } from './services/curriculum-training-item-group-management.service';
import { UpdateTrainingItemGroupsRequest } from './models/update-training-item-groups-request';
import { CurriculumTrainingItemGroupManagementConstants } from './constants/curriculum-training-item-group-management-constants';
import { NameCode } from '../../models/name-code';
import { CurriculumTrainingItemGroupsLookupRequest } from './models/curriculum-training-item-groups-lookup-request';
import { SharedConstants } from '../../constants/shared-constants';
import { UpdateCurriculumsRequest } from './models/update-curriculums-request';
import { TrainingItemGroupWithScheduled } from '../../models/TrainingItemGroupWithScheduled';


@Component({
  selector: 'app-curriculum-training-item-group-management',
  templateUrl: './curriculum-training-item-group-management.component.html',
  styleUrls: ['./curriculum-training-item-group-management.component.scss']
})
export class CurriculumTrainingItemGroupManagementComponent implements OnInit{
 @Input() isCurriculumTrainingItemGroupManagementSliderOpen: boolean = false;
  @Input() defaultTrainingItemGroups: TrainingItemGroupWithScheduled[] = [];
  @Input() defaultCurriculumsWithActiveDocumentTrainingItem: NameCode[] = [];
  @Input() defaultScheduledCurriculums: NameCode[] = [];
  @Input() trainingItemGroupsLookupRequest!: CurriculumTrainingItemGroupsLookupRequest;
  @Input() curriculumsLookupRequest!: CurriculumTrainingItemGroupsLookupRequest;
  @Output() isCurriculumTrainingItemGroupManagementActive = new EventEmitter<boolean>();
  @Input() isCurriculumDropdownVisible !: boolean;
  @Input() isTrainingItemGroupDropdownVisible !: boolean;
  curriculumTrainingItemGroupManagementHeaderText: string =
    CurriculumTrainingItemGroupManagementConstants.curriculumTrainingItemGroupManagementHeaderText;
  trainingItemGroups: NameCode[] = [];
  scheduledTrainingItemGroups: NameCode[] = [];
  curriculums : NameCode[] = [];
  sharedConstants = SharedConstants;
  valueField: string = 'code';
  labelField: string = 'name';
  selectedTrainingItemGroups:any[] = [];
  selectedScheduledTrainingItemGroupsCode:string[] = [];
  selectedCurriculums:any[] = [];
  initialSelectedTrainingItemGroups:any[] = [];
  initialSelectedScheduledTrainingItemGroups: any[] = [];
  initialSelectedCurriculums:any[] = [];
  initialSelectedScheduledCurriculums:any[] = [];
  isSaveEnabled : boolean = false;
  updateTrainingItemGroupsRequest! : UpdateTrainingItemGroupsRequest;
  updateScheduledTrainingItemGroupsRequest! : UpdateTrainingItemGroupsRequest;
  updateCurriculumsRequest! : UpdateCurriculumsRequest;
  updateScheduledCurriculumsRequest!: UpdateCurriculumsRequest;
  scheduledCurriculumCreated: any[] = [];
  nonUpdatedTIGs: any[] = [];
  curriculumCreated: any[] = [];
  isUpdateRequired : boolean = false;
  scheduledCurriculums: NameCode[] = [];
  selectedScheduledCurriculums: string[] = [];

  private allCurriculums: NameCode[] = [];
  private allTrainingItemGroups: NameCode[] = [];
 
  constructor(private confirmationService: ConfirmationService, 
    private curriculumTrainingItemGroupManagementService: CurriculumTrainingItemGroupManagementService, 
    private messageService: MessageService) { }
  ngOnInit(): void {
    this.getTrainingItemGroups();  
    this.getCurriculums();  
  
  }

  setUpdateTrainingItemsRequest(itemsToAdd : string[], itemsToRemove : string[], scheduledItemsToAdd: string[] = [], scheduledItemsToRemove: string[] = []) {
    this.updateTrainingItemGroupsRequest = {
      trainingItemNumber : this.trainingItemGroupsLookupRequest?.trainingItemId,
      trainingItemType : this.trainingItemGroupsLookupRequest?.trainingItemType,
      trainingItemsAddedTo : itemsToAdd,
      trainingItemsRemovedFrom : itemsToRemove,
      scheduledTrainingItemsAddedTo : scheduledItemsToAdd,
      scheduledTrainingItemsRemovedFrom : scheduledItemsToRemove    
    };
  }

    setUpdateCurriculumsRequest(itemsToAdd : string[], itemsToRemove : string[], scheduledItemsToAdd: string[] = [], scheduledItemsToRemove: string[] = []) {
    this.updateCurriculumsRequest = {
      trainingItemNumber : this.curriculumsLookupRequest?.trainingItemId,
      trainingItemType : this.curriculumsLookupRequest?.trainingItemType,
      curriculumsAddedTo : itemsToAdd,
      curriculumsRemovedFrom : itemsToRemove,
      scheduledCurriculumsAddedTo: scheduledItemsToAdd,
      scheduledCurriculumsRemovedFrom: scheduledItemsToRemove
    };
  }

  toggleSaveButtonAvailability() {
  this.isSaveEnabled = this.selectedTrainingItemGroups.length > 0 || 
    this.selectedCurriculums.length > 0 ||
    this.selectedScheduledCurriculums.length > 0 ||
    this.selectedScheduledTrainingItemGroupsCode.length > 0 ||
    (this.selectedTrainingItemGroups.length == 0 && this.initialSelectedTrainingItemGroups.length > 0) ||
    (this.selectedCurriculums.length == 0 && this.initialSelectedCurriculums.length > 0) ||
    (this.selectedScheduledCurriculums.length == 0 && this.initialSelectedScheduledCurriculums.length > 0) ||
    (this.selectedScheduledTrainingItemGroupsCode.length == 0 && this.initialSelectedScheduledTrainingItemGroups.length > 0); 
    this.isSaveEnabled = this.isSaveEnabled || this.isUpdateRequired; 
}

  getTrainingItemGroups() {
    this.curriculumTrainingItemGroupManagementService.getTrainingItemGroupsLookup(this.trainingItemGroupsLookupRequest).subscribe((response) => {
      // store the full list for TIG
      this.allTrainingItemGroups = response;

      // Set TIG & Scheduled TIG initial selections FIRST
      this.selectedTrainingItemGroups = this.getValidSelectedCodes(this.defaultTrainingItemGroups, this.allTrainingItemGroups, false);
      this.selectedScheduledTrainingItemGroupsCode = this.getValidSelectedCodes(this.defaultTrainingItemGroups, this.allTrainingItemGroups, true);

      // Store initial states
      this.initialSelectedTrainingItemGroups = [...this.selectedTrainingItemGroups];
      this.initialSelectedScheduledTrainingItemGroups = [...this.selectedScheduledTrainingItemGroupsCode];


      this.FilterDropdownOptions(this.allTrainingItemGroups, this.trainingItemGroups, this.selectedScheduledTrainingItemGroupsCode);
      this.FilterDropdownOptions(this.allTrainingItemGroups, this.scheduledTrainingItemGroups, this.selectedTrainingItemGroups);

      this.toggleSaveButtonAvailability();
      this.setUpdateTrainingItemsRequest([], []);
    })
  }

  getCurriculums(){
  this.curriculumTrainingItemGroupManagementService.getCurriculumsLookup(this.curriculumsLookupRequest).subscribe((response)=>{
    // Store the full list
    this.allCurriculums = response;
    
    // Set initial selections FIRST
    this.selectedCurriculums = this.defaultCurriculumsWithActiveDocumentTrainingItem.map(item => item.code);

    this.selectedScheduledCurriculums = Array.from(
    new Set(this.defaultScheduledCurriculums?.map(item => item.code) || [])
    );
    
    // Store initial states
    this.initialSelectedCurriculums = [...this.selectedCurriculums];
    this.initialSelectedScheduledCurriculums = [...this.selectedScheduledCurriculums];
    
    // THEN filter the dropdown options
    this.filterCurriculumDropdownOptions();
    
    this.toggleSaveButtonAvailability();
    this.setUpdateCurriculumsRequest([],[]);
  })
}

  setTrainingItemGroups = () => {
    this.toggleSaveButtonAvailability();
    this.FilterDropdownOptions(this.allTrainingItemGroups, this.scheduledTrainingItemGroups, this.selectedTrainingItemGroups);
  }

  setCurriculums = () => {
    this.toggleSaveButtonAvailability();
    this.filterCurriculumDropdownOptions(); // Filter after selection change
  }

  saveCurriculumTrainingItemGroupManagement = () => { 
    if(this.isTrainingItemGroupDropdownVisible){
      this.saveTrainingItemGroupManagement();
    }
    if(this.isCurriculumDropdownVisible){
      this.saveCurriculumsManagement();
    }
    
  }

  saveTrainingItemGroupManagement = () => {
    const addedItems = this.selectedTrainingItemGroups.filter(item => 
      !this.initialSelectedTrainingItemGroups.some(initialItem => initialItem === item)
    );
    const removedItems = this.initialSelectedTrainingItemGroups.filter(initialItem => 
      !this.selectedTrainingItemGroups.some(item => item === initialItem)
    );

    const scheduledAddedItems = this.selectedScheduledTrainingItemGroupsCode.filter(item => 
      !this.initialSelectedScheduledTrainingItemGroups.some(initialItem => initialItem === item)
    );
    const scheduledRemovedItems = this.initialSelectedScheduledTrainingItemGroups.filter(initialItem => 
      !this.selectedScheduledTrainingItemGroupsCode.some(item => item === initialItem)
    );
    this.setUpdateTrainingItemsRequest(addedItems,removedItems, scheduledAddedItems, scheduledRemovedItems);
    if((addedItems.length === 0 && removedItems.length === 0) && (scheduledAddedItems.length === 0 && scheduledRemovedItems.length === 0)){
      return;
    }
    this.curriculumTrainingItemGroupManagementService.updateTrainingItemGroups(this.updateTrainingItemGroupsRequest)
    .subscribe(
      (response) => {
        this.nonUpdatedTIGs = response; 
        if (this.nonUpdatedTIGs.length > 0) {
          let removedItems = this.nonUpdatedTIGs.join(", ");
            this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: SharedConstants.TrainingItemGroupManagement_ValidationMessage,
            detail: removedItems,
            sticky: true
          });
        }
        else {
          if(scheduledAddedItems.length > 0 || scheduledRemovedItems.length > 0){
          this.messageService.add({
            severity: SharedConstants.Severity_Success,
            summary: SharedConstants.ScheduledCurriculum_SuccessMessage,
            sticky: false
          });
        }
          if(addedItems.length > 0 || removedItems.length > 0){
          this.messageService.add({
            severity: SharedConstants.Severity_Success,
            summary: SharedConstants.TrainingItemGroupManagement_SuccessMessage,
            sticky: false
          });
        }
          this.closeSlider(); // Trigger reload on successful update
      }
      },
      (error) => {
        this.messageService.add({
          severity: SharedConstants.Severity_Error,
          summary: SharedConstants.ErrorMessageSummary,
          detail: SharedConstants.ErrorMessageDetail,
          sticky: true
        });
      }
    );
  }

  saveCurriculumsManagement = () => { 
    const addedItems = this.selectedCurriculums.filter(item =>
      !this.initialSelectedCurriculums.some(initialItem => initialItem === item)
    );
    const removedItems = this.initialSelectedCurriculums.filter(item =>
   !this.selectedCurriculums.includes(item) &&
   !this.selectedScheduledCurriculums.includes(item) 
 );
 const scheduledAddedItems = this.selectedScheduledCurriculums.filter(item => 
      !this.initialSelectedScheduledCurriculums.some(initialItem => initialItem === item)
    );
    const scheduledRemovedItems = this.initialSelectedScheduledCurriculums.filter(initialItem => 
      !this.selectedScheduledCurriculums.some(item => item === initialItem)
    );
    this.setUpdateCurriculumsRequest(addedItems, removedItems, scheduledAddedItems, scheduledRemovedItems);
    if((addedItems.length === 0 && removedItems.length === 0 && !this.isUpdateRequired) && (scheduledAddedItems.length === 0 && scheduledRemovedItems.length === 0)){
      this.closeSlider();
      return;
    }
    this.curriculumTrainingItemGroupManagementService.updateCurriculums(this.updateCurriculumsRequest) //update scheduled curriculums
    .subscribe((response)=>{
      this.curriculumCreated = response;  
        if (this.curriculumCreated.length > 0) {
          this.messageService.add({
            severity: SharedConstants.Severity_Success,
            summary: SharedConstants.CurriculumCreatedMessage,
            sticky: true
          });
        }
        this.messageService.add({
          severity: SharedConstants.Severity_Success,
          summary: SharedConstants.Curriculum_SuccessMessage,
          sticky: true
        });
        this.closeSlider(); // Trigger reload on successful update
    },
    (error) => {
        this.messageService.add({
          severity: SharedConstants.Severity_Error,
          summary: SharedConstants.ErrorMessageSummary,
          detail: SharedConstants.ErrorMessageDetail,
          sticky: true
        });
      })
  }

  openConfirmationModal = () => {
    this.confirmationService.confirm({
      header: CurriculumTrainingItemGroupManagementConstants.curriculumTrainingItemGroupManagementConfirmationHeaderText,
      message: CurriculumTrainingItemGroupManagementConstants.curriculumTrainingItemGroupManagementConfirmationMessageText,
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.closeSlider();
      },
      acceptIcon : "pi pi-check",
      rejectIcon : "pi pi-times"
    });
  }

  closeSlider = (): void => {
    this.resetSlider()
    this.isCurriculumTrainingItemGroupManagementSliderOpen = false;
    this.isCurriculumTrainingItemGroupManagementActive.emit(false);
  }
  
  resetSlider() {
    this.selectedTrainingItemGroups = [];
    this.initialSelectedTrainingItemGroups = [];
    this.selectedCurriculums = [];
    this.initialSelectedCurriculums = [];
    this.selectedScheduledCurriculums = []; 
    this.initialSelectedScheduledCurriculums = []; 
    this.selectedScheduledTrainingItemGroupsCode = [];
    this.initialSelectedScheduledTrainingItemGroups = [];
    this.isSaveEnabled = false;
    this.setUpdateTrainingItemsRequest([],[]);
    this.setUpdateCurriculumsRequest([],[]);
  }

  onScheduledCurriculumsChange(): void {
    this.isUpdateRequired = true;
    this.toggleSaveButtonAvailability();
    this.filterCurriculumDropdownOptions(); // Filter after selection change
  }

  onScheduledTrainingItemGroupChange(): void {
    this.toggleSaveButtonAvailability();
    this.FilterDropdownOptions(this.allTrainingItemGroups, this.trainingItemGroups, this.selectedScheduledTrainingItemGroupsCode);
  }

  private filterCurriculumDropdownOptions(): void {
    // Filter curriculums array (exclude selected scheduled ones)
    this.curriculums = this.allCurriculums.filter(curriculum => 
      !this.selectedScheduledCurriculums.includes(curriculum.code)
    );

    // Filter scheduledCurriculums array (exclude selected regular ones)
    this.scheduledCurriculums = this.allCurriculums.filter(curriculum => 
      !this.selectedCurriculums.includes(curriculum.code)
    );
  }

  private FilterDropdownOptions(sourceList: NameCode[], dropDownOptions: NameCode[],selectedItems: string[]): void {
    dropDownOptions.length = 0;
    dropDownOptions.push(...sourceList.filter(item => !selectedItems.includes(item.code)));
  }

  private getValidSelectedCodes(sourceList: TrainingItemGroupWithScheduled[], allGroups: NameCode[], isScheduled: boolean): string[] {
  const codes = sourceList
    .filter(item => item.isScheduled === isScheduled)
    .map(item => item.code);
  // Only keep codes that exist in allGroups
  return codes.filter(code => allGroups.some(group => group.code === code));
}
  
}
